import script from "./dt-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./dt-modal.vue?vue&type=script&setup=true&lang=js"

import "./dt-modal.vue?vue&type=style&index=0&id=98f073d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98f073d4"]])

export default __exports__